import React, { useState } from "react";
import {
  Box,
  Input,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  GridItem,
  Heading,
  Text,
  VStack,
  Card,
  CardBody,
} from "@chakra-ui/react";

const vaccineData = {
  dldbvb: [
    { id: "BVB001", name: "Autogenous Vaccine", lastupdated: "18/08/2568", updatedby: "สำนักงานเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", location01: "/vaccineinfo/VaccineImage_IBH.jpg", location02: "/vaccineinfo/AutogenousRollup01.jpg", location03: "/vaccineinfo/AutogenousRollup02.jpg", target: "_blank" },
  ],
  cattle: [
    { id: "cattle001", name: "การใช้วัคซีนป้องกันโรคสำหรับโคเนื้อ", lastupdated: "18/08/2568", updatedby: "สำนักงานเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", location: "document/04 - Bro_โคเนื้อ.pdf", target: "_blank" },
    { id: "cattle002", name: "การใช้วัคซีนป้องกันโรคปากและเท้าเปื่อยในโคมนม", lastupdated: "18/08/2568", updatedby: "สำนักงานเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", location: "document/06 - Bro_โคนม.pdf", target: "_blank" },
    { id: "cattle003", name: "การใช้วัคซีนป้องกันโรคคอบวม (เฮโมรายิกเซพติซีเมีย)", lastupdated: "18/08/2568", updatedby: "สำนักงานเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", location: "document/05 - Bro_โรคคอบวม.pdf", target: "_blank" },
    { id: "cattle003", name: "การใช้วัคซีนป้องกันโรคลัมปี สกิน", lastupdated: "18/08/2568", updatedby: "สำนักงานเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", location: "document/09 - Bro_Lumpy Skin.pdf", target: "_blank" },
  ],
  pig: [
    { id: "pig001", name: "การใช้วัคซีนป้องกันโรคสำหรับสุกร", lastupdated: "18/08/2568", updatedby: "สำนักงานเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", location: "document/03 - Bro_สุกร.pdf", target: "_blank" },
  ],
  poultry: [
    { id: "poultry001", name: "การใช้วัคซีนป้องกันโรคสำหรับเป็ด", lastupdated: "18/08/2568", updatedby: "สำนักงานเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", location: "document/01 - Bro_เป็ด.pdf", target: "_blank" },
    { id: "poultry001", name: "การใช้วัคซีนป้องกันโรคสำหรับไก่พื้นเมือง", lastupdated: "18/08/2568", updatedby: "สำนักงานเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", location: "document/02 - Bro_ไก่.pdf", target: "_blank" },
  ],
};

const highlights = [
    { title: "คู่มือการใช้วัคซีนกรมปศุสัตว์", description: "เอกสารเผยแพร่ของ สำนักเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์ โดยมีวัตถุประสงค์สำหรับให้เจ้าหน้าที่หรืออาสาสมัครปศุสัตว์ อาสาสมัครสาธารณสุข และเกษตรกรผู้ใช้วัคซีนของกรมปศุสัตว์ ใช้วัคซีนและเก็บรักษาวัคซีนได้อย่างถูกต้อง", lastupdated: "18/08/2568", updatedby: "สำนักงานเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", location: "document/คู่มือการใช้วัคซีนกรมปศุสัตว์Update030567.pdf", target: "_blank" },
    { title: "การใช้วัคซีนกรมปศุสัตว์", description: "ข้อควรทราบ และควรปฏิบัติก่อน-หลังการทำวัคซีน รวมถึงวิธีใช้วัคซีนชนิดต่างๆ ที่ผลิดโดย สำนักเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", lastupdated: "18/08/2568", updatedby: "สำนักงานเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", location: "document/07 - Bro_Animal Vaccine.pdf", target: "_blank" },
    { title: "การใช้สารทดสอบโรคแอนติเจนบรูเซลโลซีส ชนิด Rose Bengal", description: "ข้อมูลเกี่ยวกับโรคบรูเซลโลซีส (Brucellosis) หรือ โรคแท้งติดต่อ รวามถึงการทดสอบและคัดกรองโรค", lastupdated: "18/08/2568", updatedby: "สำนักงานเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์", location: "document/08 - Bro_Bengal.pdf", target: "_blank" },
];

const VaccineInfo = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const filterVaccines = (category) => {
    return vaccineData[category].filter((vaccine) =>
      vaccine.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  return (
    <Box p={6} maxW="1200px" mx="auto">
      {/* Header */}
      <Heading mb={4} textAlign="center">
        ศูนย์รวมข้อมูลวัคซีนปศุสัตว์
      </Heading>

      {/* Search Box */}
      <Input
        placeholder="ค้นหาวัคซีน..."
        mb={6}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {/* Highlights */}
      <Grid templateColumns="repeat(3, 1fr)" gap={6} mb={6}>
        {highlights.map((highlight, index) => (
          <Card key={index} borderRadius="lg" p={4} boxShadow="md">
            <CardBody>
              <Heading size="md" mb={2} color="blue.600">
                {highlight.title}
              </Heading>
              <br />
              <Text>{highlight.description}</Text>
              <br />
              <Text color="grey">วันที่ปรับปรุงข้อมูล : {highlight.lastupdated}</Text>
              <Text color="grey">ผู้ปรับปรุงข้อมูล : {highlight.updatedby}</Text>
              <br />
              <Text color="orange.600"><a href = {highlight.location} target = {highlight.target}> ดาวน์โหลดไฟล์เอกสาร </a></Text>
            </CardBody>
          </Card>
        ))}
      </Grid>

      {/* Vaccine List Tabs */}
      <Tabs variant="enclosed">
        <TabList>
          <Tab>Autogenous Vaccine</Tab>
          <Tab>วัคซีนสำหรับโค-กระบือ</Tab>
          <Tab>วัคซีนสำหรับสุกร</Tab>
          <Tab>วัคซีนสำหรับสัตว์ปีก</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <VStack align="stretch" spacing={4}>
              {filterVaccines("dldbvb").map((vaccine) => (
                <Box key={vaccine.id} p={4} borderWidth="1px" borderRadius="lg">
                  <Heading size="md">{vaccine.name}</Heading>
                  <br />
                  <Text color="grey">วันที่ปรับปรุงข้อมูล : {vaccine.lastupdated}</Text>
                  <Text color="grey">ผู้ปรับปรุงข้อมูล : {vaccine.updatedby}</Text>
                  <br />
                  <table align="center" width="100%" cellPadding="10" cellSpacing="0">
                    <tbody>
                      <tr>
                        <td align="center" colSpan={2}>
                          <img src={vaccine.location01} alt={vaccine.name} width="400" style={{ maxWidth: "95%", height: "auto" }} />Autogenous Vaccine สำหรับสัตว์ปีก วัคซีนโรคอินคลูซันบอดี เฮปาไตติส ชนิดโมโนวาเลนท์
                        </td>
                      </tr> 
                      <tr>
                        <td align="center" >
                          <img src={vaccine.location02} alt={vaccine.name} style={{ maxWidth: "90%", height: "auto" }} />
                        </td>
                        <td align="center" >
                          <img src={vaccine.location03} alt={vaccine.name} style={{ maxWidth: "90%", height: "auto" }} />
                        </td>
                      </tr> 
                    </tbody>
                  </table>
                </Box>
              ))}
            </VStack>
          </TabPanel>
          <TabPanel>
            <VStack align="stretch" spacing={4}>
              {filterVaccines("cattle").map((vaccine) => (
                <Box key={vaccine.id} p={4} borderWidth="1px" borderRadius="lg">
                  <Heading size="md" color="blue.600">{vaccine.name}</Heading>
                  <br />
                  <Text color="grey">วันที่ปรับปรุงข้อมูล : {vaccine.lastupdated}</Text>
                  <Text color="grey">ผู้ปรับปรุงข้อมูล : {vaccine.updatedby}</Text>
                  <br />
                  <Text color="orange.600"><a href = {vaccine.location} target = {vaccine.target}> ดาวน์โหลดไฟล์เอกสาร </a></Text>
                </Box>
              ))}
            </VStack>
          </TabPanel>

          <TabPanel>
            <VStack align="stretch" spacing={4}>
              {filterVaccines("pig").map((vaccine) => (
                <Box key={vaccine.id} p={4} borderWidth="1px" borderRadius="lg">
                  <Heading size="md" color="blue.600">{vaccine.name}</Heading>
                  <br />
                  <Text color="grey">วันที่ปรับปรุงข้อมูล : {vaccine.lastupdated}</Text>
                  <Text color="grey">ผู้ปรับปรุงข้อมูล : {vaccine.updatedby}</Text>
                  <br />
                  <Text color="orange.600"><a href = {vaccine.location} target = {vaccine.target}> ดาวน์โหลดไฟล์เอกสาร </a></Text>
                </Box>
              ))}
            </VStack>
          </TabPanel>

          <TabPanel>
            <VStack align="stretch" spacing={4}>
              {filterVaccines("poultry").map((vaccine) => (
                <Box key={vaccine.id} p={4} borderWidth="1px" borderRadius="lg">
                  <Heading size="md">{vaccine.name}</Heading>
                  <br />
                  <Text color="grey">วันที่ปรับปรุงข้อมูล : {vaccine.lastupdated}</Text>
                  <Text color="grey">ผู้ปรับปรุงข้อมูล : {vaccine.updatedby}</Text>
                  <br />
                  <Text color="orange.600"><a href = {vaccine.location} target = {vaccine.target}> ดาวน์โหลดไฟล์เอกสาร </a></Text>
                </Box>
              ))}
            </VStack>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default VaccineInfo;
